module.exports = __webpack_public_path__ + "img/cathy.f66fb090.jpg";